import { render } from "./App.vue?vue&type=template&id=d3718670"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d3718670&lang=css"
script.render = render

export default script